import Endereco from './Endereco.js';

export default class CepService {
    constructor(resource) {
        this._resource = resource
    }

    getEndereco(cep) {
        let cleanValue = cep.replace(/\D/g, '');

        return this._resource
            .get(`crm/cep/${cleanValue}`)
            .then(res => {
                let result = res.body;

                if(result.cep != '') {
                    return result;
                } else {
                    return new Endereco();
                }
            }, err => {
                console.log(err);
                throw new Error('Não foi possível consultar o CEP');
            })
    }
}


// WEBPACK FOOTER //
// ./src/domain/cep/CepService.js